import { isNil } from 'lodash'
import React, { useState, type FC } from 'react'
import { t } from 'i18next'
import { useStopPathway } from '../../hooks/useStopPathway'
import { AlertDialog, Input } from '@awell-health/design-system'

interface StopPathwayModalProps {
  onClose: () => void
  careflow_id: string | undefined
  patientName?: string
  careflowName?: string
}

export const StopPathwayModal: FC<StopPathwayModalProps> = ({ onClose, careflow_id, patientName, careflowName }) => {
  const { stopPathway } = useStopPathway()
  const [reasonToStopPathway, setReasonToStopPathway] = useState<string>()

  const handleStopPathway = async (): Promise<void> => {
    if (!isNil(careflow_id)) {
      await stopPathway({
        pathway_id: careflow_id,
        reason: reasonToStopPathway
      })
      handleCloseModal()
    }
  }

  const handleCloseModal = (): void => {
    setReasonToStopPathway(undefined)
    onClose()
  }

  return (
    <div>
      <AlertDialog
        title={t('stop_pathway')}
        text={
          patientName
            ? t('stop_patient_pathway_heading_personalized', { patientName, careflowName })
            : t('stop_patient_pathway_heading')
        }
        button={{
          label: t('stop_pathway_confirmation_button'),
          buttonAction: handleStopPathway
        }}
        secondaryButton={{
          label: t('cancel'),
          buttonAction: handleCloseModal
        }}
      >
        <div className="mt-6">
          <Input
            label={t('stop_patient_reason_heading')}
            placeholder={t('stop_patient_reason_hint')}
            value={reasonToStopPathway ?? ''}
            onChange={e => setReasonToStopPathway(e.target.value)}
          />
        </div>
      </AlertDialog>
    </div>
  )
}
